import { Outlet } from "react-router-dom";
import { useTranslation } from "@/core/i18n";
import { Spinner } from "@/newComponents";

import { ProductSubscriptionsProvider } from "@/modules/productSubscriptions";
import { ThemeProvider } from "providers/ThemeProvider";

export const Component = () => {
  return (
    <ProductSubscriptionsProvider>
      <ThemeProvider>
        <Outlet />
      </ThemeProvider>
    </ProductSubscriptionsProvider>
  );
};

export const HydrateFallback = () => {
  const { t } = useTranslation();
  return (
    <main
      aria-busy="true"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white p-6 text-foreground"
    >
      <Spinner aria-label={t("common.loading")} />
      <p className="type-body-sm">{t("common.loading")}</p>
    </main>
  );
};
